import React from "react";
import { useTranslation } from "react-i18next";
import { ShieldAlert } from "lucide-react";

/**
 * Avis légal discret, affiché juste avant confirmation / paiement
 * d'un médicament sur ordonnance. Pas de case à cocher.
 */
const CnomUsurpationNotice = () => {
  const { t } = useTranslation("seller");

  return (
    <div
      className="flex gap-2.5 rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5"
      role="note"
    >
      <ShieldAlert className="h-4 w-4 text-slate-500 flex-shrink-0 mt-0.5" aria-hidden />
      <p className="text-xs text-slate-600 leading-relaxed">
        <span className="font-medium text-slate-700">{t("cnomNotice.title")} </span>
        {t("cnomNotice.body")}
      </p>
    </div>
  );
};

export default CnomUsurpationNotice;
